import { InstallBaseData } from 'services/basesServices';
import {
  LocationSummary,
  OrderSummaryItem,
  ORDER_SUMMARY_ICONS,
} from '../OrderReviewSection';
import { buildDeliveryForecast } from './buildDeliveryForecast';

export interface RefuelDataLike {
  baseName: string;
  currentPercentage: string;
  refuelDate: string;
  isFixedRoute: boolean;
}

export interface ResponsibleLike {
  name: string;
  phone: string;
  email: string;
  details?: string;
}

export const toLocationSummaries = (
  selectedBases: InstallBaseData[],
  refuelData: RefuelDataLike[],
  responsibleByBase: Record<string, ResponsibleLike>
): LocationSummary[] =>
  selectedBases.map((base) => {
    const refuel = refuelData.find((r) => r.baseName === base.name);
    const responsible = responsibleByBase[base.name];
    const numberOfDaysToSuplay =
      base.baseTerritory?.base?.numberOfDaysToSuplay ?? 0;
    const forecast = buildDeliveryForecast(
      refuel?.refuelDate,
      numberOfDaysToSuplay
    );

    const items: OrderSummaryItem[] = [
      {
        icon: ORDER_SUMMARY_ICONS.local,
        label: 'Local do abastecimento',
        value: `${base.address}, ${base.number} - ${base.complement}`,
      },
      {
        icon: ORDER_SUMMARY_ICONS.gas,
        label: 'Nível atual do gás',
        value: refuel ? `${refuel.currentPercentage}% do gás` : '-',
      },
      {
        icon: ORDER_SUMMARY_ICONS.delivery,
        label: forecast.label || 'Previsão de entrega',
        value: forecast.value || '-',
      },
      {
        icon: ORDER_SUMMARY_ICONS.responsible,
        label: 'Responsável pelo recebimento',
        value: responsible ? `${responsible.name} · ${responsible.phone}` : '-',
      },
    ];

    return { id: base.name, title: base.nickname, items };
  });

export default toLocationSummaries;
